import React from 'react';

export default function EnergyIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2L4.5 13H12L11 22L19.5 11H12L13 2Z"
        fill={color}
      />
    </svg>
  );
}
